import React from 'react';
import { useHistory } from 'react-router-dom';

import LoginForm from '../../components/common/LoginForm/LoginForm';

const LoginPage = () => {
  const history = useHistory();

  const onSuccess = (responseJson: any) => {
    if (responseJson.grade?.testingTypeId) {
      localStorage.testingTypeId = responseJson.grade.testingTypeId;
    }

    if (responseJson.school?.name) {
      localStorage.schoolName = responseJson.school.name;
    }

    if (responseJson.role === 1) return history.push('/admin');
    if (responseJson.role === 2) return history.push('/teacher');
    return history.push('/testing/intro');
  };

  return <LoginForm onSuccess={onSuccess} darkenBg={false} />;
};

export default LoginPage;
